<template>
  <div :class="getStarAlignment">
    <span
      v-for="star in 5"
      :key="star"
      class="star"
      :class="{
        'no-rated-star': selectedRating == 0 && star == 3 && tooltip,
        height40: !tooltip
      }"
      @click="handleStarClick($event, star)"
    >
      <img
        :src="getRatingIcon(star)"
        class="star-image"
        v-if="star !== selectedRating"
      />
      <VueLottiePlayer
        v-else
        name="confettiAnim"
        :animationData="
          require(`../../assets/Csat/ratingstar${selectedRating}.json`)
        "
        width="40px"
        height="40px"
        :class="{ 'rated-star': tooltip }"
      />
      <span
        v-if="star === selectedRating && isOrderHistoryPage"
        class="rating-tag"
        >{{ ratingTag }}</span
      >
    </span>
  </div>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { staticImgBaseUrl } from "../../config/apiEndpoints";
export default {
  name: "StarRating",
  props: {
    selectedRating: { required: false, default: 0 },
    tooltip: { required: false, default: true },
    align: { required: false },
    emptyGrey: { required: false, default: false },
    ratingTag: { required: false, default: "" },
    isOrderHistoryPage: { required: false, default: false },
    cancelBubble: { required: false, default: false },
  },
  components: {
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  mounted() {},
  methods: {
    getRatingIcon(star) {
      return this.selectedRating < star
        ? !this.emptyGrey
          ? staticImgBaseUrl + "/images/global/ratingstar.svg"
          : staticImgBaseUrl + "/images/global/ratingstaremptyfilled.svg"
        : staticImgBaseUrl + "/images/global/ratingstarfilled.svg";
    },
    handleStarClick(event, star) {
      if(this.cancelBubble){
        this.$emit("starClick", star, event);
      }else{
        this.$emit("starClick", star);
      }
    },
  },
  computed: {
    getStarAlignment() {
      return this.align == "left"
        ? "d-flex align-items-center justify-content-left star-ratings"
        : "d-flex justify-content-center align-items-center";
    },
  },
};
</script>
